import { FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Block from "src/components/BlockList/Block";

interface ValidationsBlockListProps {}

const ValidationsBlockList: FC<ValidationsBlockListProps> = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Block
        blockType="document_validation_segment"
        description="Solicita y verifica ID, DNI o Cédulas de identidades"
        theme="dark"
      />
      <Block
        blockType="email_validation_segment"
        description="Verifica correos electrónicos"
        theme="dark"
      />
      <Block
        blockType="phone_validation_segment"
        description="Verifica teléfonos de usuarios"
        theme="dark"
      />
    </div>
  );
};

ValidationsBlockList.defaultProps = {};

export default ValidationsBlockList;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "absolute",
    zIndex: 100,
    top: "120%",
    transform: "translate(-30%, 0)",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    minWidth: "600px",
    columnGap: "25px",
    rowGap: "10px",
    padding: "50px 16px",
    border: "solid 1px #eff2f8",
    backgroundColor: "#fff",

    "&:before": {
      content: "''",
      width: "0",
      height: "0",
      position: "absolute",
      display: "block",
      top: "-15px",
      left: "45%",
      borderLeft: "15px solid transparent",
      borderBottom: "15px solid rgba(137, 89, 89, 0.08)",
      borderRight: "15px solid transparent",
    },
  },
}));
